export default function HeroSection() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const directions = [
    'Профилактика конфликтов', 'Диагностика причин', 'Сложные разговоры',
    'Переговоры', 'Поиск решения', 'Контроль договорённостей',
  ];

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20modern%20conceptual%20illustration%20of%20two%20professional%20silhouettes%20in%20a%20constructive%20workplace%20dialogue%20resolving%20a%20disagreement%2C%20connected%20by%20balanced%20geometric%20shapes%20and%20flowing%20light%20paths%20symbolizing%20negotiation%20mediation%20and%20finding%20common%20ground%2C%20deep%20teal%20and%20emerald%20green%20color%20palette%20with%20warm%20cream%20highlights%2C%20soft%20gradient%20background%2C%20minimalist%20corporate%20art%20style%20with%20subtle%20depth%2C%20sense%20of%20calm%20resolution%20and%20mutual%20understanding%2C%20elegant%20premium%20editorial%20design%20aesthetic%2C%20clean%20composition%20with%20generous%20negative%20space%2C%20no%20text%20no%20logos%20no%20branding&width=1920&height=1080&seq=conflict-hero-2026&orientation=landscape"
          alt="Тренинг по управлению конфликтами — обучение руководителей и сотрудников"
          className="absolute top-1/2 left-1/2 w-[177.77777778vh] min-w-full h-[56.25vw] min-h-full -translate-x-1/2 -translate-y-1/2 object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/75 via-black/65 to-black/80"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full pt-32 md:pt-24 pb-12 md:pb-16">
        <div className="max-w-3xl">
          <h1 className="text-2xl md:text-4xl lg:text-5xl font-extrabold text-white mb-5 leading-tight">
            Тренинг по управлению конфликтами: учим руководителей превращать сложные ситуации в управляемый рабочий процесс
          </h1>
          <p className="text-sm md:text-lg text-white/85 mb-4 leading-relaxed max-w-xl">
            Конфликты между сотрудниками, подразделениями и руководителями неизбежны. Задача руководителя — не избегать их, а уметь вовремя замечать напряжение, разбирать причины и переводить конфликт в конструктивное решение.
          </p>
          <p className="text-sm text-white/60 mb-6">
            Корпоративный тренинг для руководителей и команд. Практика на реальных рабочих ситуациях компании.
          </p>

          <div className="flex flex-wrap gap-2 mb-8">
            {directions.map((dir) => (
              <span key={dir} className="bg-white/10 backdrop-blur-sm border border-white/20 text-white/90 px-3 py-1.5 rounded-full text-xs font-medium">
                {dir}
              </span>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row gap-3">
            <button
              onClick={() => scrollTo('contact')}
              className="bg-teal-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-sm sm:text-base font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
            >
              Заказать тренинг по конфликтам
              <i className="ri-arrow-right-line"></i>
            </button>
            <button
              onClick={() => scrollTo('contact')}
              className="border border-white/30 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-sm sm:text-base font-semibold hover:bg-white/10 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
            >
              Обсудить конфликтную ситуацию
              <i className="ri-chat-3-line"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}